module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAABBCAYAAAAdU76iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAuSURBVEhLY6zar/afAQdggtJYwagkEIxKAsGoJBCMSgLBqCQQjEoCwagkAwMDAE7XAuAOo5QvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/portal/co-bar.png
// module id = 985
// module chunks = 10